<template>
  <div class="horizontal-stepper-sausage">
    <span class="horizontal-stepper-sausage__count">{{ countValidatedSteps }}/{{ stepper.length }}</span>
    <div class="sausage-step">
      <span id="completeStep" class="step-bar valid" />
      <span id="incompleteStep" class="step-bar" />
    </div>
  </div>
</template>

<script>
import eventBus from '@tools/event-bus';
import stepperStatus from './Steppers/stepperEnum';

export default {
  name: 'HorizontalStepperGuidedSearch',
  props: {
    stepper: { type: Array, default: () => [] },
  },
  computed: {
    countValidatedSteps() {
      return this.stepper.filter((s) => [ stepperStatus.DONE, stepperStatus.IN_PROGRESS ].includes(s.stepColor)).length;
    },
  },
  mounted() {
    this.refreshStepper();

    this.stepChangedListener = () => {
      this.refreshStepper();
    };

    eventBus.addEventListener('sausage-step-changed', this.stepChangedListener);
  },
  beforeUnmount() {
    eventBus.removeEventListener('sausage-step-changed', this.stepChangedListener);
  },
  methods: {
    refreshStepper() {
      const stepCompleteElement = document.getElementById('completeStep');
      const stepIncompleteElement = document.getElementById('incompleteStep');
      const validWidthPercentage = (this.countValidatedSteps / this.stepper.length) * 100;
      if (stepCompleteElement) {
        stepCompleteElement.style.width = `${validWidthPercentage}%`;
      }
      if (stepIncompleteElement) {
        stepIncompleteElement.style.width = `${100 - validWidthPercentage}%`;
      }
    },
  },
};
</script>
